import React, { createContext, useContext, useMemo, useState } from 'react';

const RequestContext = createContext(null);

export function RequestProvider({ children }) {
  const [request, setRequest] = useState([]);
  const [professionProofs, setProfessionProofs] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);

  const contextValues = useMemo(
    () => ({
      request,
      setRequest,
      professionProofs,
      setProfessionProofs,
      professions,
      setProfessions,
      municipalities,
      setMunicipalities,
    }),
    [request, professionProofs, professions, municipalities]
  );
  return (
    <RequestContext.Provider value={contextValues}>
      {children}
    </RequestContext.Provider>
  );
}

export default function useRequestContext() {
  const requestContext = useContext(RequestContext);

  return requestContext;
}
